<script>
	import {ruslat, latrus, lcorrect, casecorrect} from './translit'

	let rus = "";
	let lat = "";

	function changeRus() {
		lat = casecorrect(ruslat(rus));
	}

	function changeLat() {
		rus = latrus(lat);
	}
</script>

<main>
	<h1>Транслит</h1>
	<div>
		<label for="ta-rus" class="l">РУС</label>
		<textarea id="ta-rus" rows="7" bind:value={rus} on:keyup={changeRus}/>
<!--		<div>{latrus(ruslat(rus))}</div>-->
	</div>
	<div>
	</div>
	<div>
		<label for="ta-lat" class="r">LAT</label>
		<textarea id="ta-lat" rows="7" bind:value={lat} on:keyup={changeLat}/>
<!--		<div>{casecorrect(ruslat(latrus(lat)))}</div>-->
	</div>
</main>

<style>
	main {
		text-align: center;
		padding: 0.2em;
		/*max-width: 240px;*/
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 3em;
		font-weight: 100;
	}

	label {
		margin: 0.4em;
		font-weight: bold;
	}

	.l {
		text-align: left;
	}
	.r {
		text-align: right;
	}

	textarea {
		width: 100%;
	}

	@media (min-width: 640px) {
		main {
			max-width: 600px;
			padding: 1em;
		}
	}

	@media (min-width: 800px) {
		main {
			max-width: 760px;
			padding: 1em;
		}
	}

	@media (min-width: 1200px) {
		main {
			max-width: 1160px;
			padding: 1em;
		}
	}
</style>
